module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25834",
      "conversations-internal-schema": "static-1.12454",
      "head-dlb": "static-1.4754",
      "hs-test-utils": "static-1.7789",
      "hubspot-url-utils": "static-1.3943",
      "HubStyleTokens": "static-2.11207",
      "I18n": "static-7.1564",
      "jasmine-runner": "static-1.6256",
      "quartz": "static-1.6704",
      "react": "static-7.178",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.483",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5914",
      "enviro": "static-4.387",
      "hs-promise-rejection-tracking": "static-1.5291",
      "PortalIdParser": "static-2.349",
      "raven": "static-3.5624",
      "raven-hubspot": "static-1.5931",
      "bend-plugin-trellis-migration": "static-1.3211",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17642",
      "cv-backend-services": "static-1.1496",
      "hub-http": "static-1.5966",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4437",
      "quartz-config": "static-1.482",
      "quartz-core": "static-1.5923",
      "transmute": "static-2.85",
      "HeadJS": "static-2.706",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7492",
      "framer-motion": "static-1.67",
      "hs-test-utils-bend-plugin": "static-1.2900",
      "msw": "static-1.39",
      "react-redux": "static-7.67",
      "redux": "static-4.16",
      "testing-library": "static-1.147",
      "foundations-theming": "static-1.4194",
      "i18n-data": "static-1.216",
      "metrics-js": "static-1.9420",
      "moment-timezone": "static-5.78",
      "react-utils": "static-2.5158",
      "jasmine": "static-4.4112",
      "history": "static-4.47",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.61",
      "styled-components": "static-2.85",
      "UIComponents": "static-3.8154",
      "visitor-ui-component-library-icons": "static-1.5725",
      "bender-build-tools": "static-1.2926",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4432",
      "apollo-stack-hubspot": "static-3.81",
      "classnames": "static-2.10",
      "cssUtils": "static-1.726",
      "customer-data-objects": "static-1.7430",
      "customer-data-ui-utilities": "static-1.9609",
      "data-fetching-client": "static-1.9463",
      "FileManagerCore": "static-1.38342",
      "FileManagerLib": "static-1.38483",
      "foundations-assets": "static-1.4619",
      "graphql": "static-1.77",
      "hs-promise-utils": "static-1.5376",
      "hubspot-apollo-client": "static-1.4664",
      "icons": "static-2.620",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.94",
      "rpc-client-utils": "static-1.4416",
      "salesImages": "static-1.520",
      "timezone-utils": "static-2.5029",
      "ui-gdpr-components": "static-1.10131",
      "ts-schema": "static-1.3888",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.132",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.789",
      "hubspotter-http": "static-1.4462",
      "mobile-manifest-mixins": "static-1.479",
      "module-federation": "static-1.18",
      "quartz-auth": "static-1.379",
      "quartz-head": "static-1.369",
      "quartz-i18n": "static-1.379",
      "quartz-routing": "static-1.134",
      "quartz-test": "static-1.379",
      "quick-fetch": "static-1.3719",
      "react-rhumb": "static-1.16427",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.469",
      "usage-tracker-container": "static-1.7106",
      "bend-plugin-foundations-components": "static-1.3761",
      "floating-ui": "static-1.51",
      "foundations-theming-specialty": "static-1.1910",
      "hs-story-utils": "static-1.9213",
      "tanstack-table": "static-1.50",
      "trellis-assets": "static-1.1145",
      "ui-images": "static-2.1087",
      "bend-plugin-foundations-theming": "static-1.2677",
      "foundations-theming-base": "static-1.3179",
      "stylex": "static-1.27",
      "HubStyle": "static-2.11515",
      "sassPrefix": "static-1.151",
      "inbound-db-properties-service-client": "static-1.3660",
      "property-translator": "static-1.5197",
      "react-dnd-compat": "static-1.4406",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8305",
      "audio-components": "static-1.5589",
      "cropperjs": "static-1.10",
      "file-manager-components": "static-1.22843",
      "FileManagerImages": "static-1.35994",
      "foundations-components-legacy": "static-1.517",
      "immerable": "static-1.3938",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8670",
      "urlinator": "static-1.4317",
      "usage-tracker-core": "static-1.6966",
      "video-components": "static-1.12517",
      "video-data-lib": "static-1.34172",
      "video-embed": "static-1.35006",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.123",
      "hub-http-shared-msw-handlers": "static-1.9440",
      "hubspotter-http-shared-msw-handlers": "static-1.9438",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20243",
      "chirp-fetch": "static-1.1667",
      "ContentUtils": "static-1.67576",
      "copilot-toolkit": "static-1.10482",
      "sanitize": "static-1.4259",
      "sanitize-text": "static-1.7923",
      "content-assistance-lib": "static-1.7425",
      "usage-tracker": "static-1.7116",
      "ui-addon-iframeable": "static-1.8826",
      "video-components-external": "static-1.10514",
      "unified-auth-core-lib": "static-1.465",
      "content-icons-ui": "static-1.2148",
      "social-insights-client-types": "static-1.21278",
      "SharedI18nStrings": "static-1.180",
      "outpost": "static-1.3989",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4589",
      "integrations-lib": "static-1.15366",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5378",
      "magpie-types": "static-1.4838",
      "simple-logging-lib": "static-1.2834",
      "superstore": "static-1.4555",
      "ui-addon-video-player": "static-1.8479",
      "ui-coaching-tips": "static-1.27902",
      "navigation-messaging": "static-1.6546",
      "content-media-composition-data-lib": "static-1.11394",
      "content-media-compositions": "static-2.15401",
      "idb-keyval": "static-1.39",
      "media-bridge-lib": "static-1.18537",
      "fsm": "static-1.3515",
      "flux-actions": "static-1.306",
      "frontend-preferences-client": "static-1.7708",
      "integrations-error-boundary-lib": "static-1.12781",
      "integrations-tracking-lib": "static-1.5369",
      "laboratory-lib": "static-3.6946",
      "native-integrations-shared-strings": "static-1.7572",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10157",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.10919",
      "ui-shepherd-react": "static-3.9929",
      "reactive-lib": "static-1.509",
      "growth-onboarding-feedback-components": "static-1.6369",
      "hls.js": "static-1.34",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2782",
      "foundations-components-test-utils": "static-1.4975",
      "react-dlb": "static-1.71",
      "crm-record-cards-service-types": "static-1.3437",
      "framework-data-schema-resolvers": "static-1.6654",
      "location-customization-utils-lib": "static-1.8514",
      "batch-promise": "static-1.1333",
      "conditional-properties-service-client": "static-1.3608",
      "crm-pipelines-api-client-types": "static-1.3949",
      "framework-builder-read-service-client": "static-1.3817",
      "framework-data-schema-quick-fetch": "static-1.6559",
      "inbound-db-meta-service-client": "static-1.3402",
      "multi-currency-client-types": "static-1.3502",
      "persist-promise": "static-1.3490"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25834",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12454",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-test-utils": "/hs-test-utils/static-1.7789",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3943",
      "HubStyleTokens": "/HubStyleTokens/static-2.11207",
      "I18n": "/I18n/static-7.1564",
      "jasmine-runner": "/jasmine-runner/static-1.6256",
      "quartz": "/quartz/static-1.6704",
      "react": "/react/static-7.178",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.483",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5914",
      "enviro": "/enviro/static-4.387",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "raven": "/raven/static-3.5624",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3211",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17642",
      "cv-backend-services": "/cv-backend-services/static-1.1496",
      "hub-http": "/hub-http/static-1.5966",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4437",
      "quartz-config": "/quartz-config/static-1.482",
      "quartz-core": "/quartz-core/static-1.5923",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.706",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7492",
      "framer-motion": "/framer-motion/static-1.67",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2900",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.67",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.147",
      "foundations-theming": "/foundations-theming/static-1.4194",
      "i18n-data": "/i18n-data/static-1.216",
      "metrics-js": "/metrics-js/static-1.9420",
      "moment-timezone": "/moment-timezone/static-5.78",
      "react-utils": "/react-utils/static-2.5158",
      "jasmine": "/jasmine/static-4.4112",
      "history": "/history/static-4.47",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.61",
      "styled-components": "/styled-components/static-2.85",
      "UIComponents": "/UIComponents/static-3.8154",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5725",
      "bender-build-tools": "/bender-build-tools/static-1.2926",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4432",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.726",
      "customer-data-objects": "/customer-data-objects/static-1.7430",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9609",
      "data-fetching-client": "/data-fetching-client/static-1.9463",
      "FileManagerCore": "/FileManagerCore/static-1.38342",
      "FileManagerLib": "/FileManagerLib/static-1.38483",
      "foundations-assets": "/foundations-assets/static-1.4619",
      "graphql": "/graphql/static-1.77",
      "hs-promise-utils": "/hs-promise-utils/static-1.5376",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4664",
      "icons": "/icons/static-2.620",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.94",
      "rpc-client-utils": "/rpc-client-utils/static-1.4416",
      "salesImages": "/salesImages/static-1.520",
      "timezone-utils": "/timezone-utils/static-2.5029",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10131",
      "ts-schema": "/ts-schema/static-1.3888",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.132",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.789",
      "hubspotter-http": "/hubspotter-http/static-1.4462",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
      "module-federation": "/module-federation/static-1.18",
      "quartz-auth": "/quartz-auth/static-1.379",
      "quartz-head": "/quartz-head/static-1.369",
      "quartz-i18n": "/quartz-i18n/static-1.379",
      "quartz-routing": "/quartz-routing/static-1.134",
      "quartz-test": "/quartz-test/static-1.379",
      "quick-fetch": "/quick-fetch/static-1.3719",
      "react-rhumb": "/react-rhumb/static-1.16427",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.469",
      "usage-tracker-container": "/usage-tracker-container/static-1.7106",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3761",
      "floating-ui": "/floating-ui/static-1.51",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1910",
      "hs-story-utils": "/hs-story-utils/static-1.9213",
      "tanstack-table": "/tanstack-table/static-1.50",
      "trellis-assets": "/trellis-assets/static-1.1145",
      "ui-images": "/ui-images/static-2.1087",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2677",
      "foundations-theming-base": "/foundations-theming-base/static-1.3179",
      "stylex": "/stylex/static-1.27",
      "HubStyle": "/HubStyle/static-2.11515",
      "sassPrefix": "/sassPrefix/static-1.151",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3660",
      "property-translator": "/property-translator/static-1.5197",
      "react-dnd-compat": "/react-dnd-compat/static-1.4406",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8305",
      "audio-components": "/audio-components/static-1.5589",
      "cropperjs": "/cropperjs/static-1.10",
      "file-manager-components": "/file-manager-components/static-1.22843",
      "FileManagerImages": "/FileManagerImages/static-1.35994",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.517",
      "immerable": "/immerable/static-1.3938",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8670",
      "urlinator": "/urlinator/static-1.4317",
      "usage-tracker-core": "/usage-tracker-core/static-1.6966",
      "video-components": "/video-components/static-1.12517",
      "video-data-lib": "/video-data-lib/static-1.34172",
      "video-embed": "/video-embed/static-1.35006",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.123",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9440",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9438",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20243",
      "chirp-fetch": "/chirp-fetch/static-1.1667",
      "ContentUtils": "/ContentUtils/static-1.67576",
      "copilot-toolkit": "/copilot-toolkit/static-1.10482",
      "sanitize": "/sanitize/static-1.4259",
      "sanitize-text": "/sanitize-text/static-1.7923",
      "content-assistance-lib": "/content-assistance-lib/static-1.7425",
      "usage-tracker": "/usage-tracker/static-1.7116",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8826",
      "video-components-external": "/video-components-external/static-1.10514",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.465",
      "content-icons-ui": "/content-icons-ui/static-1.2148",
      "social-insights-client-types": "/social-insights-client-types/static-1.21278",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "outpost": "/outpost/static-1.3989",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4589",
      "integrations-lib": "/integrations-lib/static-1.15366",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5378",
      "magpie-types": "/magpie-types/static-1.4838",
      "simple-logging-lib": "/simple-logging-lib/static-1.2834",
      "superstore": "/superstore/static-1.4555",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8479",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27902",
      "navigation-messaging": "/navigation-messaging/static-1.6546",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11394",
      "content-media-compositions": "/content-media-compositions/static-2.15401",
      "idb-keyval": "/idb-keyval/static-1.39",
      "media-bridge-lib": "/media-bridge-lib/static-1.18537",
      "fsm": "/fsm/static-1.3515",
      "flux-actions": "/flux-actions/static-1.306",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7708",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12781",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5369",
      "laboratory-lib": "/laboratory-lib/static-3.6946",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7572",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10157",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10919",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9929",
      "reactive-lib": "/reactive-lib/static-1.509",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6369",
      "hls.js": "/hls.js/static-1.34",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2782",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4975",
      "react-dlb": "/react-dlb/static-1.71",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3437",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6654",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8514",
      "batch-promise": "/batch-promise/static-1.1333",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3608",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3949",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6559",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3402",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3502",
      "persist-promise": "/persist-promise/static-1.3490"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.25834",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};